// Use gw-pl-accordion-chevron to provide a chevron containing HTML
//   <gw-pl-accordion-chevron is-open="isOpen"></gw-pl-accordion-chevron>

import templateStr from 'text!edge/platform/widgets/accordion/directives/templates/accordion-chevron.html';

export default [function () {
    return {
        restrict: 'EA',
        replace: true,
        template: templateStr,
        scope: {
            isOpen: '=',
            flavor: '@'
        },
        link: function link($scope) {
            return $scope.$watch('flavor', function (f) {
                $scope._flavor = f || 'default';
            });
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/accordion/directives/accordionChevron.js
// module id = 1087
// module chunks = 0